import { Alert, AlertIcon, Button, Card, Flex, Stack, Text, VStack, useToast } from '@chakra-ui/react';

import { useCreateAgreementNotifications } from '@partiu/api/notifications/hooks';
import { useNavigate } from 'react-router-dom';
import { useNotificationCentralContext } from '../notification-central.context';
import { IStep } from './interfaces';
import { TestNotificationCard } from './shared';
import { scheduleLabel } from './labels';

export function ConfirmPushStep({ HeaderComponent }: IStep) {
  const toast = useToast();
  const navigate = useNavigate();

  const { formData } = useNotificationCentralContext();

  const mutation = useCreateAgreementNotifications({
    onSuccess() {
      toast({
        title: 'Notificação agendada!',
        description: 'O push será enviado para os usuários do app na data agendada.',
        status: 'success',
      });
      navigate('/central-de-notificacoes?tab=push');
    },
    onError() {
      toast({
        title: 'Erro',
        description: 'Não foi possível agendar o push. Por favor entre em contato em: suporte@partiu.com.br',
        status: 'error',
      });
    },
  });

  return (
    <>
      <HeaderComponent title={'Confirmação dos dados'} />
      <Stack direction={['column', 'row']} alignItems={'flex-start'} spacing={5} width="100%">
        <VStack width={{ base: '100%', lg: '600px' }} spacing={5}>
          <Card width="100%" padding={4}>
            <VStack height={'100%'} spacing={5} alignItems={'flex-start'}>
              <Alert status="warning" borderRadius="md" fontSize="sm">
                <AlertIcon />
                O push é enviado para todos os usuários do app do clube.
              </Alert>
              <Text fontWeight={'bold'}>{formData?.type === 'recurring' ? 'Envio recorrente' : 'Data de envio'}</Text>
              <Text fontSize={'sm'}>{scheduleLabel(formData)}</Text>
            </VStack>
            <Button
              marginTop={4}
              width={'100%'}
              colorScheme={'green'}
              isLoading={mutation.isLoading}
              onClick={() => mutation.mutate(formData)}
            >
              Confirmar e agendar
            </Button>
          </Card>
          <TestNotificationCard formData={formData} />
        </VStack>
        <Card title={'Visualização'} maxWidth={'400px'} minWidth={{ base: '100%', md: '400px' }} paddingY="8px">
          <VStack backgroundPosition="top-left" width="100%" spacing={0}>
            <Flex
              flexDir="column"
              padding={0}
              backgroundColor="white"
              borderRadius="5%"
              wordBreak="normal"
              overflowWrap="break-word"
              width="100%"
            >
              <Flex flexDir="column" px={2} justifyContent="center" padding={'16px'}>
                <Text fontWeight="bold">{formData.pushSubject}</Text>
                <Text>{formData.pushBody}</Text>
              </Flex>
            </Flex>
          </VStack>
        </Card>
      </Stack>
    </>
  );
}
